'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/vpn/enable/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "enabled" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/vpn/enable/StaticView#model
   * @type {actions/vpn/enable/EditVpnEnabled}
   */

  template: twig({data: tpl}),
});
